import { cn } from '@finn/ui-utils';
import { ReactNode } from 'react';

type SpacingWrapperProps = {
  noPaddingTop?: boolean;
  className?: string;
  children?: ReactNode;
};

export function SpacingWrapper({
  children,
  noPaddingTop,
  className,
}: SpacingWrapperProps) {
  return (
    <div className={cn(noPaddingTop ? '' : 'pt-24 md:pt-40', className)}>
      {children}
    </div>
  );
}
